const config: any = {
  baseURL: process.env.REACT_APP_API_BASEURL,
  timeout: 30000,
};

export default config;
